
function decodeExp(jwt: string): number | null {
    try {
        const payload = jwt.split(".")[1];
        if (!payload) return null;
        const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
        const { exp } = JSON.parse(json) as { exp?: number };
        return typeof exp === "number" ? exp * 1000 : null;
    } catch {
        return null;
    }
}

export const tokenStore = {

    getAccessToken(): string | null { return localStorage.getItem("auth_token"); },

    getTokenExpiry(): number | null {
        const token = this.getAccessToken();
        if (!token) return null;
        return decodeExp(token);
    },


    isTokenExpired(): boolean {
        const expiry = this.getTokenExpiry();
        if (expiry === null) return false;
        const BUFFER_MS = 30_000;
        return Date.now() >= expiry - BUFFER_MS;
    },


};

